import React, { Component } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { Footer, Section } from "@sunwing/components";
import commonUtilities from "utilities/common";
import "./appFooter.css";

const AppFooter = (props) => {
    const { authState, oktaAuth } = useOktaAuth();
    const auth = authState?.isAuthenticated;
    let { language } = props;

    if(auth) {
        language = commonUtilities.getLanguage();
    }
    
    if (language) {

        return (
            
            <div className="application-footer font-size-14">
                
                {language === "en" ?
                    <footer className=""
                        data-section-theme="light">
                        <Section>
                            <div className="quick-links d-flex">
                                <div>
                                    <a className="Footer-module--footer__links--a172c" target="_blank" href="https://www.westjet.com/en-ca/contact">Contact Us</a>
                                </div>
                                <div>
                                    <a className="Footer-module--footer__links--a172c" target="_blank" href="https://www.westjet.com/en-ca/legal">Legal</a>
                                </div>
                                <div>
                                    <a className="Footer-module--footer__links--a172c" target="_blank" href="https://www.westjet.com/en-ca">WestJet.com</a>
                                </div>
                            </div>
                        </Section>
                        <Section>
                            <div className="copy-right">
                                <p>
                                    Copyright © 2026 WestJet Vacations Inc. TICO #50026549 | Consumer Protection BC #84473
                                </p>
                            </div>
                        </Section>
                    </footer> :
                    <footer className=""
                        data-section-theme="light">
                        <Section>
                            <div className="quick-links d-flex">
                                <div>
                                    <a className="Footer-module--footer__links--a172c" target="_blank" href="https://www.westjet.com/fr-ca/nous-contacter">Contactez-nous</a>
                                </div>
                                <div>
                                    <a className="Footer-module--footer__links--a172c" target="_blank" href="https://www.westjet.com/fr-ca/legal">Légal</a>
                                </div>
                                <div>
                                    <a className="Footer-module--footer__links--a172c" target="_blank" href="https://www.westjet.com/fr-ca">WestJet.com</a>
                                </div>
                            </div>
                        </Section>
                        <Section>
                            <div className="copy-right">
                                <p>
                                    Droit d’auteur © 2025 Vacances WestJet Inc. TICO n° 50026549 | Consumer Protection BC n° 84473
                                </p>
                            </div>
                        </Section>
                    </footer>

                }
                
            </div>
            
        );

    }
};

export default AppFooter;